import { render, staticRenderFns } from "./DiskFile.vue?vue&type=template&id=678f68c8&scoped=true"
import script from "./DiskFile.vue?vue&type=script&lang=js"
export * from "./DiskFile.vue?vue&type=script&lang=js"
import style0 from "./DiskFile.vue?vue&type=style&index=0&id=678f68c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f68c8",
  null
  
)

export default component.exports